"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = e => {
    const products = e.data;
    if (typeof window.adobeDataLayer === 'undefined')
        return;
    window.adobeDataLayer.push({
        component: {
            productlistItems: null,
        },
    });
    const productData = [];
    products.forEach((product, index) => {
        productData.push({
            brand: product.brandName || 'NA',
            category: product.category || 'NA',
            listPosition: index + 1,
            productID: product.identifierValue || 'NA',
            productName: product.productName || 'NA',
            productVariants: product.routineName || 'NA',
            quantity: product.quantity || 'NA',
        });
    });
    const analyticsEvent = {};
    analyticsEvent.event = 'productListingImpressions';
    analyticsEvent.component = {
        productlistItems: productData,
    };
    window.adobeDataLayer.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
